import { useState } from 'react'
import { DashboardWrapper } from "../../../container/dashboardWrapper"
import { Link } from 'react-router-dom';
import {
    Container,
    ContentWrapper,
    OverviewSection,
    Grid,
    AnnouncementContainer,
    AdminDashboardCountGrid,
    AdminDashboardCountGridItem,
} from "../../../styles/dashboard";
import {
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { ModuleHeader } from "../../../components/module-header";
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Table } from '../../../components/table/table';
import { SchoolData } from '../../../services/tableData';
import { CustomModal } from '../../../components/modal'
import { TableWrapper } from '../../../styles/assignment/assignment';
import { Button } from '../../../components/button'
// import { RowDots } from "../../../components/table/row-menu";
import { MdSearch, MdCreate, MdDelete } from "react-icons/md";
import { Input } from '../../../components/input'
import { ExtraTableButtons, InstructorButtonWrapper, DeleteInstructorContainer, InstructorCustomAvatar } from '../../../styles/instructors/instructors';
import { AdminUsageChart } from '../../../components/admin-usage-analytics';

const AdminStudents = () => {
    const [showModal, setShowModal] = useState(false);
    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
        },
        {
            name: "Motto",
            selector: (row) => row.motto,
        },
        {
            name: "Highest Level",
            selector: (row) => row.highestLevel,
        },
        {
            name: "School Code",
            selector: (row) => row.schoolCode,
        },
        {
            name: "",
            selector: (row) => row.schoolCode,
            // width: "50px",
            cell: () => {
                // return (
                //     <RowDots
                //         options={["Edit Instructor", "Delete"]}
                //     // optionsFns={[() => router.push(`edit`)]}
                //     />
                // );
                return (
                    <ExtraTableButtons>
                        <div className="icon-container"><MdCreate /></div>
                        <div onClick={() => setShowModal(true)} className="icon-container"><MdDelete /></div>
                    </ExtraTableButtons>
                );
            },
        },
    ];


    return (
        <>
            <CustomModal onClose={() => setShowModal(false)} showModal={showModal}>
                <DeleteInstructorContainer>
                    <p className='title'>What do you wish?</p>
                    <p className='sub-title'>Do you wish to disable or delete this student?</p>
                    <div>
                        <InstructorCustomAvatar alt="Name" src="/assets/images/account-avatar.webp" />
                    </div>

                    <div className="button-container">
                        <Button size='small'>DISABLE</Button>
                        <Button size='small' variant="secondary">DELETE</Button>
                    </div>

                </DeleteInstructorContainer>
            </CustomModal>
            <DashboardWrapper>
                <ContentWrapper>
                    <Container>
                        <MainContent>
                            <Heading>
                                Students
                            </Heading>
                            <Breadcrumb
                                crumbs={['Students']}
                            />
                            <OverviewSection>
                                <ModuleHeader title="overview" />
                                <AdminDashboardCountGrid>
                                    <AdminDashboardCountGridItem active>
                                        <span style={{ fontSize: '1.4rem' }} className="title">
                                            Library Uploads
                                        </span>
                                        <br />
                                        <span className="count">
                                            0
                                        </span>
                                    </AdminDashboardCountGridItem>
                                    <AdminDashboardCountGridItem>
                                        <span className="title">
                                            Groups Created
                                        </span>
                                        <br />
                                        <span className="count">
                                            3
                                        </span>
                                    </AdminDashboardCountGridItem>
                                    <AdminDashboardCountGridItem>
                                        <span className="title">
                                            Support Tickets
                                        </span>
                                        <br />
                                        <span className="count">
                                            1
                                        </span>
                                    </AdminDashboardCountGridItem>
                                    <AdminDashboardCountGridItem>
                                        <span className="title">
                                            Tasks Created
                                        </span>
                                        <br />
                                        <span className="count">
                                            2
                                        </span>
                                    </AdminDashboardCountGridItem>
                                </AdminDashboardCountGrid>
                                <AdminUsageChart />
                            </OverviewSection>
                            <AnnouncementContainer>
                                <ModuleHeader title="INSTRUCTORS" />
                                <div style={{ marginTop: '3.3rem' }}>
                                    <InstructorButtonWrapper>
                                        <form>
                                            <Input
                                                startAdornment={<MdSearch />}
                                                placeholder='Search for students'
                                                className="search"
                                                fullWidth
                                                style={{ width: '45.5rem' }}
                                            />
                                        </form>
                                        <Link to='/admin/students/add'>
                                            <Button size='small'>ADD student</Button>
                                        </Link>
                                        <Button size='small' variant="secondary">Print</Button>
                                    </InstructorButtonWrapper>
                                    <TableWrapper>
                                        <Table
                                            columns={columns}
                                            data={SchoolData || []}
                                        />
                                    </TableWrapper>
                                </div>
                            </AnnouncementContainer>
                        </MainContent>
                    </Container>
                </ContentWrapper>
            </DashboardWrapper>
        </>
    )
}

export default AdminStudents
